import { createContext } from 'react';
import { initialAuthState } from '../reducers/Auth';

export const AuthContext = createContext(initialAuthState);
